import React from 'react';
import {Layout42Main} from "../../Support/Layout";
import {SlideElement} from "../../../animate/AnimateElement";
import {Icon} from "../../DuckIcon";
import HiLightCode from "../../Support/hiLightCode";

const HeroSection = (props) => {
    const heroString = `<div className=" hero hero-bg rounded-t-l has-background border is-flex jt-center align-center py-xxl " >
        <img  src="https://i.imgur.com/fKfrWXx.png" alt=""/>
        <div className="container-m columns layout-2-1 s-vertical-revert align-center p-xl">
            <div className="col">
                <div className="hi-xxl text-bold font-text">
                    Build Amazing
                    Elements
                </div>
                <div className="columns vertical">
                    <div className="text-xs col">Trang web sử dụng biểu tượng Duck như là một phần của
                        <br/>
                        thương hiệu của Hine Studio.
                    </div>
                    <div className="is-flex gapx-xs">
                        <div className="btn "> Try It  </div>
                        <div className="btn btn-outline"> <Icon className={"text-l"} icon={"music-play"}></Icon>Watch demo</div>
                    </div>
                </div>
            </div>
            <div className="col">
        </div>
    </div>
</div>`
    return (
        <div className={"section"}>
            <div className="title-xxl mb-l">Hero</div>

            <div className="section container-xl">
                <Layout42Main>
                    <>
                        <div className="text-m">
                            "Hero section" chủ yếu có tác dụng tạo ra một ấn tượng mạnh mẽ và thu hút sự chú ý người
                            dùng ngay từ khi họ truy cập trang web hoặc ứng dụng.
                            <br/>Nó thường đóng vai trò quan trọng
                            trong việc truyền đạt thông điệp chính và thúc đẩy hành động từ phía người dùng.
                        </div>

                        <div className="text-m mt-l">Dưới đây là một ví dụ:</div>
                    </>
                    <>
                        <div
                            className=" hero hero-bg rounded-t-l has-background border is-flex jt-center align-center py-xxl ">
                            <img src="https://i.imgur.com/fKfrWXx.png" alt=""/>
                            <div className="container-m columns layout-2-1 s-vertical-revert align-center p-xl">

                                <div className="col">
                                    <SlideElement>
                                        <div className="hi-xxl text-bold font-text">
                                            Build Amazing
                                            Elements
                                        </div>

                                    </SlideElement>
                                    <div className="columns vertical">
                                        <div className="text-xs col">Trang web sử dụng biểu tượng Duck như là một phần
                                            của
                                            <br/>
                                            thương hiệu của Hine Studio.
                                        </div>
                                        <div className="is-flex gapx-xs">
                                            <div className="btn "> Try It</div>
                                            <div className="btn btn-outline"><Icon className={"text-l mr-s"}
                                                                                   icon={"music-play"}></Icon>Watch demo
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <svg style={{width: "100%", height: "auto"}} viewBox="0 0 400 400" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M335.938 6.76579H64.0623C32.4183 6.76579 6.7658 32.4183 6.7658 64.0623V214.626H171.791V92.94C171.791 63.8599 195.365 40.2858 224.445 40.2858C253.525 40.2858 277.099 63.8599 277.099 92.94V99.2674L277.907 99.6173L323.647 119.421C332.961 122.613 332.961 135.785 323.647 138.976L310.677 143.42L310.67 143.422L310.222 143.576L310.221 143.576L307.462 144.521C305.407 145.225 305.133 148.019 307.012 149.109C308.695 150.085 308.695 152.516 307.012 153.492L281.026 168.564C279.51 169.444 278.211 170.098 277.099 170.545V328.88C277.099 357.316 260.411 381.854 236.294 393.234H335.938C367.582 393.234 393.234 367.581 393.234 335.937V64.0623C393.234 32.4183 367.582 6.76579 335.938 6.76579ZM206.143 400H335.938C371.318 400 400 371.318 400 335.937V64.0623C400 28.6817 371.318 0 335.938 0H64.0623C28.6817 0 0 28.6817 0 64.0623V335.937C0 343.899 1.45248 351.522 4.10694 358.555C10.9684 378.156 27.5053 393.207 47.999 397.969C53.1323 399.295 58.515 400 64.0623 400H205.865C205.903 400 205.941 400 205.979 400C206.033 400 206.088 400 206.143 400ZM206.905 393.228V392.792H201.047C188.256 390.469 178.557 379.273 178.557 365.812V221.392H182.208H270.334V328.88C270.334 364.113 242.02 392.732 206.905 393.228ZM270.334 214.626V92.94C270.334 67.5966 249.788 47.0516 224.445 47.0516C199.101 47.0516 178.557 67.5965 178.557 92.94V214.626H182.208H270.334ZM171.791 221.392V365.812C171.791 376.776 176.953 386.536 184.979 392.792H61.9189C57.6865 392.792 53.5673 392.31 49.6131 391.397C31.5748 386.71 16.991 373.456 10.466 356.238C9.00959 352.056 8.04794 347.642 7.65113 343.066C15.1125 344.429 22.7309 345.128 30.4211 345.128C64.0288 345.128 96.26 331.777 120.025 308.013L117.633 305.621L120.025 308.013C143.085 284.953 156.339 253.919 157.104 221.392H171.791ZM7.44498 336.142V221.792H30.4211H150.326C149.464 252.379 136.937 281.532 115.24 303.229C92.7448 325.724 62.2344 338.362 30.4211 338.362C22.652 338.362 14.9607 337.608 7.44498 336.142ZM305.268 138.121L305.269 138.121L321.454 132.575C324.671 131.473 324.671 126.924 321.454 125.822L321.203 125.736L320.959 125.63L277.907 106.99L277.906 120.293C277.888 119.849 277.815 119.186 277.563 118.431C277.728 118.933 277.886 119.694 277.892 120.576H277.906V120.58H277.905H277.892C277.894 120.914 277.874 121.264 277.825 121.624C277.876 121.296 277.905 120.948 277.905 120.58V151.308C277.905 154.354 277.775 157.252 277.667 159.674C277.632 160.446 277.6 161.169 277.574 161.833C277.562 162.161 277.552 162.471 277.543 162.763L277.631 162.712L299.499 150.028C297.918 145.481 299.998 139.927 305.268 138.121ZM277.906 120.576L277.906 120.293C277.911 120.401 277.912 120.496 277.912 120.576H277.906ZM277.684 167.049C277.683 167.049 277.68 167.04 277.675 167.018C277.681 167.038 277.684 167.049 277.684 167.049Z"
                                              fill="black"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <HiLightCode codeString={heroString}></HiLightCode>
                    </>

                </Layout42Main>
            </div>
        </div>
    );
}

export default HeroSection;